import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

interface DeleteModalProps {
  open: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteModal: FC<DeleteModalProps> = ({
  open,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    try {
      setConfirmLoading(true);
      await onConfirm();
      onCancel();
    } catch (error) {
      // 错误处理在调用方完成
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title={<span><ExclamationCircleFilled style={{ color: '#faad14', marginRight: 8 }} />{t('common.tip')}</span>}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('common.confirm')}
      cancelText={t('common.cancel')}
      confirmLoading={confirmLoading || loading}
      destroyOnClose
    >
      <div>
        {t('requirement.delSubTip')}
      </div>
    </Modal>
  );
};

export default DeleteModal;